/* eslint-disable no-unused-expressions */
import { HiDocumentAdd } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import { updateData } from "../../../hooks/update";
import { apiPath, RoutePath } from "../../../utility/Constant";
import Dropdown from "../../../components/shared/dropdown/Dropdown";

const JobsContentCreate = () => {
  const { jobsApi } = apiPath;
  const { jobsContent } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      required: false,
    },
    {
      elementType: "input",
      label: "subtitle",
      type: "Text",
      name: "subtitle",
      required: false,
    },
    {
      elementType: "input",
      label: "date",
      type: "date",
      name: "date",
      required: false,
    },
    {
      elementType: "input",
      label: "country name",
      type: "Text",
      name: "country_name",
      required: false,
    },
    {
      elementType: "richTextEditor",
      label: "description",
      type: "richTextEditor",
      name: "description",
      required: false,
    },
    {
      elementType: "select",
      label: "Job Status",
      type: "select",
      name: "status",
      options: ["active", "hired", "hidden"],
      required: false,
    },
  ];

  const update = async (data) => {
    data.slug = "content";
    data.identifier = data.title;

    const res = await updateData(jobsApi, data, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + jobsContent;
      }, 600);
    }
  };

  return (
    <div>
      <div className="md:pl-8 my-4">
        <h1 className="font-oswald font-bold text-2xl -mb-6 uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new job
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default JobsContentCreate;
